import { render, staticRenderFns } from "./DocToOrg.vue?vue&type=template&id=950da2b8&"
import script from "./DocToOrg.vue?vue&type=script&lang=js&"
export * from "./DocToOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports